<script lang="ts" context="module">
  export type VasPriceTileVariantType = 'base' | 'addon' | 'saving' | 'ac-mount' | 'lmd';
</script>

<script lang="ts">
  import { getJoodExpiredMembershipType, getPriceHTMLOrFree, JoodMembershipType } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import { getJoodCardImageUrlNew } from '../services/pdp-data-services';

  export let data;
  export let active: boolean;
  export let variant: VasPriceTileVariantType = 'base';
  export let readonly = false;
  export let priceType: JoodMembershipType = 'NOPRIME';

  $: isNoPlan = data?.noPlanOption;
  $: visible = !data?.noPlanOption || variant !== 'saving';
  $: savings = getSavings(variant, data);
  $: oldPrice = data?.servicePrice?.value;
  $: displayPrice = oldPrice - savings;
  $: joodCardImageUrl = getJoodCardImageUrlNew(priceType);

  function getSavings(variant: VasPriceTileVariantType, data) {
    const userJoodLevel = getJoodExpiredMembershipType();
    const joodPriceType = userJoodLevel === 'BASICPRIME' ? 'basicPrimeDiscountPrice' : 'vipPrimeDiscountPrice';
    return variant === 'saving' ? data?.[joodPriceType]?.value : data?.discountedPrice?.value || 0;
  }
</script>

{#if visible}
  <button
    class="c_vas-price-tile vas-price-tile variant-{variant}"
    class:active
    class:readonly
    disabled={readonly}
    on:click
    class:no-plan-tile={isNoPlan}
  >
    {#if isNoPlan}
      <section class="name">{data?.vasType?.name}</section>
    {:else}
      <section class="label">
        <strong>
          {data?.vasType?.label}
        </strong>
        {#if variant !== 'saving' && data?.vasType?.name}
          ({data?.vasType?.name})
        {/if}
      </section>

      <section class="price">
        {@html getPriceHTMLOrFree(displayPrice)}
        {#if savings > 0}
          <img src={joodCardImageUrl} alt="Jood Card" />
        {/if}
      </section>
      <!-- {#if variant === 'saving' && savings > 0}
        <section class="savings">
          <span class="striked-off">{oldPrice}</span>
          <strong class="orange-text">
            {@html getStr('extra.cart.saved.amt', [globalCurrencyTag, savings])}
          </strong>
        </section>
      {/if} -->
    {/if}
    {#if active}
      <section class="active-icon">
        <Icon glyph="check" type="font" desktopSize={24} />
      </section>
    {/if}
  </button>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .vas-price-tile {
    position: relative;
    text-align: start;
    background-color: $primary-white;
    padding: 12px 16px;
    border: 1px solid $secondary-gray-02;
    border-radius: 8px;
    color: $neutral-dark-01;
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    img {
      width: 24px;
      border-radius: 2px;
    }
    &.no-plan-tile {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.variant-base {
      // flex-grow: 1;
      flex-basis: 30%;
      flex-shrink: 1;
    }
    &.variant-addon,
    &.variant-ac-mount {
      flex-basis: 50%;
    }
    &.variant-saving {
      border: 0;
      padding: 8px 8px 12px 8px;
      width: 110px;
      height: 82px;
      @include desktop-max-width {
        height: 80px;
        width: 98px;
      }

      .name {
        color: $neutral-dark-01;
      }
    }
    &.variant-lmd {
      flex-basis: calc(50% - 6px);
    }
    &.readonly {
      cursor: default;
    }

    .label {
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      color: $neutral-dark-03;
    }
    .name {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      margin-top: 2px;
    }
    .price {
      font-size: 16px;
      line-height: 18px;
      font-weight: 400;
      margin: 4px 0;
      gap: 4px;
      display: flex;
      @include responsive {
        font-size: 14px;
        line-height: 16px;
      }
    }
    .savings {
      .striked-off {
        color: $neutral-dark-03;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        text-decoration: line-through;
      }
      .orange-text {
        color: $functional-orange;
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
  :global {
    .jood-savings-accordion {
      @include responsive {
        .c_expirecard {
          align-items: flex-start;
        }
      }
      .vas-price-tile .label {
        font-size: 14px !important;
        line-height: 16px !important;
        @include responsive {
          font-size: 12px !important;
          line-height: 14px !important;
        }
      }
    }
  }
</style>
